<template>
    <main style="margin-top: 25px;">
        <section>

            <!--mensagem inicial bem vindo teste-->
            <div class="content-960" v-if="step == 1">
                <div class="wrapper-960 clearfix">

                    <div class="card">

                        <div class="card-body">
                            <div class="podeConterIMG" v-html="teste.avaliacao.mensagemInicial"></div>
                        </div>

                        <div class="card-footer">
                            <ul class="pagination">
                                <li class="page-item">
                                    <button class="btn btn-sm btn-default" @click="iniciarVisualizacaoProvisoria()">Iniciar <i class="fa fa-arrow-right"></i></button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

            <!--questoes e perguntas-->
            <div class="content-960" v-if="step == 2">
                <div class="wrapper-960 clearfix">

                    <!--tempo no header-->
                    <div class="row">
                        <div class="col-md-12 text-right" v-bind:class="{ 'text-danger': temporestante <= 10 }">
                            <small v-if="temporestante <= 10">Seu tempo está quase acabando</small>

                            Tempo restante: <strong>{{ temporestante }} min.</strong><br />
                        </div>
                    </div>

                    <!--barra de progresso de realização-->
                    <div class="row">
                        <div class="col-md-12">
                            <b-progress :value="progresso" variant="success" striped :animated="true" class="mb-2"></b-progress>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body" v-for="(testeQuestaoPergunta, index) in teste.collectionTesteQuestaoPergunta" v-bind:key="testeQuestaoPergunta.questaoPerguntaId" v-if="substep == index">

                            <strong>Questão {{index + 1}} - {{testeQuestaoPergunta.questaoPergunta.questao.disciplina.nome}} </strong> <!--v-html=""-->
                            <hr />

                            <small>Enunciado</small>
                            <div class="podeConterIMG" v-html="testeQuestaoPergunta.questaoPergunta.questao.enunciado" />
                            <hr />

                            <small>Pergunta</small>
                            <div class="podeConterIMG" v-html="testeQuestaoPergunta.questaoPergunta.pergunta"></div>

                            <!--pergunta do tipo alternativa-->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 1">
                                <br />
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="questaoResposta in testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta" v-bind:key="questaoResposta.questaoId">
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="questaoResposta.resposta" v-model="testeQuestaoPergunta.resposta" :value="questaoResposta.resposta" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description podeConterIMG" v-html="questaoResposta.resposta"></span>
                                        </label>
                                    </li>
                                </ul>
                            </div>

                            <!--pergunta do tipo preencha lacuna-->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 2">
                                <br />
                                <br />
                                <small>Preencha os campos abaixo de acordo com a lacuna.</small>
                                <br />
                                <div v-for="(questaoResposta, index2) in testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta" v-bind:key="questaoResposta.questaoId">
                                    <div class="row mb-4">
                                        <div class="col-0"><strong style="line-height: 35px;">[{{ questaoResposta.ordem }}]</strong></div>
                                        <div class="col-10"><input type="text" name="questaoResposta.resposta" v-model="questaoResposta.resposta" @keyup="montaRespostaCompleteLacunas(testeQuestaoPergunta)" class="form-control"></div>
                                    </div>
                                </div>
                            </div>

                            <!--pergunta do tipo dissertativa-->
                            <div v-if="testeQuestaoPergunta.questaoPergunta.questao.tipoRespostaId == 3">
                                <textarea v-model="testeQuestaoPergunta.resposta" placeholder="Insira sua resposta." class="form-control" />
                            </div>

                            <div class="form-group">
                                <label class="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" v-model="testeQuestaoPergunta.revisarDepois" value="true" class="custom-control-input">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description">Revisar resposta depois.</span>
                                </label>
                            </div>
                            <hr />

                            <!--botoes se acoes-->
                            <ul class="pagination">
                                <li class="page-item" v-if="substep != 0">
                                    <button class="btn btn-sm btn-default" @click="voltarSubstep()"><i class="fa fa-arrow-left"></i> Questão anterior</button>
                                </li>
                                <li class="page-item" v-if="substep != totalsubstep">
                                    <button class="btn btn-sm btn-default" @click="openPausar()" v-b-tooltip title="Salvar teste e continuar posteriormente."><i class="fa fa-pause"></i> Pausar teste</button>
                                </li>
                                <li class="page-item" v-if="substep != totalsubstep">
                                    <button class="btn btn-sm btn-default" @click="proximoSubstep()">Próxima questão <i class="fa fa-arrow-right"></i></button>
                                </li>
                                <li class="page-item" v-if="botaoFinalizar">
                                    <button class="btn btn-sm btn-default" @click="irParaQuestao(totalsubstep)" v-b-tooltip title="Ir para o final">Finalizar <i class="fa fa-forward"></i></button>
                                </li>
                            </ul>

                        </div>

                        <!--ultimo passo conclusão do teste-->
                        <div class="card-body" v-if="substep == totalsubstep">
                            <div>
                                Revise suas respostas abaixo antes de finalizar. Caso necessário e haja tempo disponível, você poderá alterar suas respostas.
                            </div>
                            <hr />
                            <ul class="list-group">
                                <li class="list-group-item" v-bind:class="{ 'list-group-item-warning': testeQuestaoPergunta.revisarDepois }" v-for="(testeQuestaoPergunta, index) in teste.collectionTesteQuestaoPergunta" v-bind:key="testeQuestaoPergunta.questaoPerguntaId">
                                    <strong>{{ index + 1 }}) </strong> <span class="podeConterIMG" v-html="testeQuestaoPergunta.resposta || '--'" />
                                    <a class="float-right" v-if="testeQuestaoPergunta.revisarDepois">
                                        <em v-if="testeQuestaoPergunta.resposta" @click="irParaQuestao(index)">Revisar resposta</em>
                                        <em v-if="!testeQuestaoPergunta.resposta" @click="irParaQuestao(index)">Completar resposta</em>
                                    </a>
                                </li>
                            </ul>

                            <hr />

                            <ul class="pagination">
                                <li class="page-item" v-if="substep != 0">
                                    <button class="btn btn-sm btn-default" @click="voltarSubstep()"><i class="fa fa-arrow-left"></i> Questão anterior</button>
                                </li>
                                <li class="page-item" v-if="substep == totalsubstep">
                                    <button class="btn btn-sm btn-default" @click="finalizarTeste()" v-b-tooltip title="Clique para encerrar o teste e enviar suas respostas. Não será possível cancelar essa ação depois"><i class="fa fa-check"></i> Finalizar</button>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>

            <!--mensagem de tempo esgotado-->
            <div class="content-960" v-if="step == 3">
                <div class="wrapper-960 clearfix">
                    <div class="card">
                        <div class="card-body podeConterIMG">
                            <div v-if="temporestante == 0" class="text-center text-danger">
                                Seu tempo esgotou!
                                <br />
                            </div>
                            <div>
                                <div v-if="notaobtida >= teste.avaliacao.notaAprovacao" v-html="teste.avaliacao.mensagemAprovacao"></div>
                                <div v-if="notaobtida < teste.avaliacao.notaAprovacao" v-html="teste.avaliacao.mensagemReprovacao"></div>
                                <br />
                            </div>
                            <hr />
                            <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Fechar e sair do teste" @click="closePagina()">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!--mensagem de pausa de teste-->
            <div class="content-960" v-if="step == 4">
                <div class="wrapper-960 clearfix">
                    <div class="card">
                        <div class="card-body">
                            <div>
                                <strong>
                                    Seu teste foi pausado.
                                    <br />
                                    Peça para que um colaborador da escola CNA acesse o CNA Jobs para continuar seu teste quando necessário.
                                </strong>
                                <br />
                            </div>
                            <hr />
                            <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Fechar e sair do teste" @click="closePagina()">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </section>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'


    export default {
        name: "avaliacao-form-visualizar",
        components: {},
        mixins: [base],
        props: { Id: Number },
        data: () => ({

            model: {
                avaliacaoId: "",
            },

            form: "avaliacao-form-visualizar",
            testeId: null,
            step: 0,
            substep: 0,
            totalsubstep: 0,
            notaobtida: 0,
            temporestante: 0,
            candidato: null,
            teste: null,
            dialogPausar: false,
            botaoFinalizar: false,
            resources: {
                edit: 'Teste',
            },

        }),
        computed: {
            progresso: function () {
                if (this.totalsubstep == 0) return 0;
                return this.substep / this.totalsubstep * 100;
            }
        },
        methods: {

            montaTesteProvisorio: function () {

                this.showLoading();

                new Api(this.resources.edit).put({ avaliacaoid: this.Id, attributebehavior: "LiberarTeste" }).then(data => {
                    this.$emit('on-saved', data.data)
                    this.getTeste(data.data.testeId);
                }, err => {
                    this.defaulterrorresult(err);
                })
            },

            getTeste: function (testeId) {
                this.showLoading();
                new Api('teste/gettesterealizacao').get({ id: testeId }).then(data => {
                    this.hideLoading();
                    if (data.data) {
                        this.teste = data.data;
                        console.log(this.teste);
                        this.temporestante = this.teste.tempoRestante;
                        this.step = 1;
                        this.substep = 0;
                        this.totalsubstep = this.teste.collectionTesteQuestaoPergunta.length;
                        this.preparaElementosPergunta();
                    }
                }, err => {
                    this.defaultErrorResult(err);
                });
            },

            preparaElementosPergunta: function () {
                setTimeout(() => {
                    var _elements = document.querySelectorAll("audio, video");
                    for (var i = 0; i < _elements.length; i++) {
                        var _el = _elements[i];
                        _el.setAttribute("controlsList", "nodownload");
                    }
                }, 500)
            },

            proximoSubstep() {
                this.substep++;
                if (this.substep == this.totalsubstep) this.botaoFinalizar = true;
                this.preparaElementosPergunta();
            },

            voltarSubstep() {
                this.substep--;
            },

            montaRespostaCompleteLacunas: function (testeQuestaoPergunta) {
                let _respostas = []
                testeQuestaoPergunta.questaoPergunta.collectionQuestaoPerguntaResposta.forEach(_ => {
                    if (_.resposta) _respostas.push(_.resposta);
                });
                testeQuestaoPergunta.resposta = _respostas.join([' | '])
            },

            irParaQuestao: function (index) {
                this.substep = index;
            },

            iniciarVisualizacaoProvisoria() {
                this.step = 2;
            },

            openPausar: function (model) {
                this.step = 4;
                this.model = model;
            },

            finalizarTeste() {
                let _teste = this.preparaModelSave(this.teste, { attributeBehavior: "FinalizarTeste", ehLivreRedeCna: true });
                this.showLoading();
                new Api('teste').put(_teste).then(data => {
                    this.hideLoading();
                    this.notaobtida = data.data.nota;
                    this.step = 3;
                }, err => {
                    this.defaultErrorResult(err);
                    this.step = 2;
                });
            },

            preparaModelSave(teste, newteste) {

                let _teste = JSON.parse(JSON.stringify(teste));

                _teste = Object.assign(_teste, newteste);

                _teste.collectionTesteQuestaoPergunta = _teste.collectionTesteQuestaoPergunta.map(item => {
                    item.questaoPergunta.pergunta = null;
                    item.questaoPergunta.questao = null;
                    return item;
                });

                return _teste
            },

            closePagina: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            this.montaTesteProvisorio();
        }
    };
</script>